<mat-card id='table-header'>
  <mat-toolbar class="toolbar-top">
    <div class='title'>
      <mat-icon>apps</mat-icon>
      <div>Cielo Lab</div>
    </div>
  </mat-toolbar>
</mat-card>

<div *ngIf='_authService.isAdmin'>

  <mat-card>
    <button mat-raised-button (click)='callCieloPIX()'>
      Cielo PIX
    </button>
  </mat-card>

  <mat-card>
    <img style="width: 200px" [src]="qrcodeImage"  *ngIf="qrcodeImage"/>
  </mat-card>

  <mat-card>
    <label>{{link}}</label>
  </mat-card>

  <mat-card>
    <button mat-raised-button (click)='callCieloPIXURI()'>
     check
    </button>
  </mat-card>

  <mat-card>
    <button mat-raised-button (click)='capture()'>
     Loop
    </button>
  </mat-card>

</div>